module.exports = __webpack_public_path__ + "img/Keys.12d890d.png";